var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-img"},[_c('img',{attrs:{"src":_vm.bodyImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }